import styled, { css } from 'styled-components';
import colors from '../../helpers/colors';
import fonts from '../../helpers/fonts';
import mediaQuery from '../../helpers/mediaQuery';
import spacing, { spacingWithBorder } from '../../helpers/spacing';
import { GridItem } from '../Grid';
import Icon from '../Icon';
import Link, { ButtonLink } from '../Link';
import LogoLink from '../LogoLink';
import PageWidthContainer from '../PageWidthContainer';

export const BackToTopContainer = styled(PageWidthContainer)`
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid ${colors.neutral04};

  ${mediaQuery.tabletLandscape`
    display: none;
  `}
`;

const backToTopButtonStyle = css`
  && {
    font-weight: normal;
    color: ${colors.core01};
  }
`;

export const DesktopBackToTopButton = styled(ButtonLink)`
  ${fonts.paragraph};
  ${backToTopButtonStyle}

  display: none;

  margin: ${spacing(3)} 0;

  ${mediaQuery.tabletLandscape`
    display: block;
  `}
`;

/* Empty for Motability, where overriding styling is applied */
export const BackToTopGridItem = styled(GridItem)``;
export const BreadcrumbsGridItem = styled(GridItem)``;

export const DefaultBackToTopButton = styled(ButtonLink)`
  ${fonts.paragraphSmall};
  ${backToTopButtonStyle}
  display: inline-block;

  margin: ${spacing(2)} 0;

  ${mediaQuery.tabletPortrait`
    ${fonts.paragraph};
    margin: ${spacing(2.5)};
  `}

  ${mediaQuery.tabletLandscape`
    display: none;
  `}
`;

export const BackToTopIcon = styled(Icon)`
  margin-left: ${spacing(1.25)};
`;

export const BreadcrumbsWrapper = styled(PageWidthContainer)`
  border-top: 1px solid ${colors.neutral04};
  border-bottom: 1px solid ${colors.neutral04};
`;

export const BreadcrumbsList = styled.ol`
  /* Half the gap is added as padding, and half is added as a margin on the breadcrumbs
  so that when they wrap the spacing is correct. */
  padding: ${spacingWithBorder(1, 1)} 0;

  ${mediaQuery.tabletPortrait`
    padding: ${spacingWithBorder(2, 1)} 0;
  `}

  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  margin: 0;
`;

export const TextBreadcrumb = styled.li`
  /* Half the gap is added as padding, and half is added as a margin on the breadcrumbs
  so that when they wrap the spacing is correct, adjusting for the fact the spacing between
  lines is always 16px. */
  padding: ${spacing(1)} 0;

  display: flex;
`;

const breadcrumbsTextStyle = css`
  ${fonts.paragraphSmall};

  display: flex;

  margin: 0 ${spacing(1)} 0 0;
  ${mediaQuery.tabletPortrait`
    ${fonts.paragraph};
    margin: 0 ${spacing(2)} 0 0;
  `}
`;

export const TextContainer = styled.p`
  ${breadcrumbsTextStyle};
  & {
    color: ${colors.neutral02};
  }
  margin-left: ${spacing(1)};
  ${mediaQuery.tabletPortrait`
    margin-left: ${spacing(2)};
  `}
`;

export const StyledLink = styled(Link)`
  ${breadcrumbsTextStyle};
  & {
    color: ${colors.core01};
  }
  margin-left: ${spacing(1)};
  ${mediaQuery.tabletPortrait`
    margin-left: ${spacing(2)};
  `}
`;

export const RootStyledLink = styled(Link)`
  ${breadcrumbsTextStyle};
  & {
    color: ${colors.core01};
  }
  margin-left: 0;
`;

export const Logo = styled(LogoLink)`
  img {
    height: ${spacing(2)};
    margin-right: ${spacing(2)};

    ${mediaQuery.tabletLandscape`
      height: ${spacing(3)};
    `}
  }
`;

export const RootBreadcrumb = styled.li`
  display: flex;

  margin: auto 0;
`;

export const StyledIcon = styled(Icon)`
  display: inline-block;
  margin: auto;
`;

export const BreadcrumbsContainer = styled.div`
  margin-top: ${spacing(8)};
`;
